import { State } from '@/store/modules/apm/trace/trace.store';

const getters = {
  getSelectedTraceLoading(state: State) {
    return state.selectedTraceLoading;
  },
  getCurrentPageNum(state: State) {
    return state.traceForm.paging.pageNum;
  },
};

export default getters;
